import 'posthog-js/dist/recorder'
import 'posthog-js/dist/surveys'
import 'posthog-js/dist/exception-autocapture'
import 'posthog-js/dist/tracing-headers'
import 'posthog-js/dist/web-vitals'

import posthog from 'posthog-js/dist/module.no-external'

const posthogData = document.getElementById('posthog-config').dataset

const ph = posthog.init(posthogData.key, {
  api_host: posthogData.host,
  __add_tracing_headers: [posthogData.com1Host],
  loaded: (posthog) => {
    if (!posthogData.userId || !posthogData.userEmail) return

    // Identify the logged-in user so that client-side feature flags
    // and surveys can target by person properties (e.g. email).
    posthog.identify(posthogData.userId, {
      email: posthogData.userEmail
    })

    // Track session count as a person property so that surveys and
    // feature flags can target users who have visited multiple times.
    const sessionId = posthog.get_session_id()
    const lastCountedSession = localStorage.getItem('ph_last_counted_session')

    if (sessionId && sessionId !== lastCountedSession) {
      posthog.capture('session_started', { $add: { session_count: 1 } })
      localStorage.setItem('ph_last_counted_session', sessionId)
    }
  }
})

window.posthog = ph
